import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const lightbox = new PhotoSwipeLightbox({
  gallery: '.c-media__gallery',
  children: 'a',
  pswpModule: () => import('photoswipe')
});
lightbox.init();
